import ApplicationController from '../application_controller'

class EventTypeReportController extends ApplicationController {
  static values = { year: Number }
  static targets = ['additionalParams', 'available', 'comment', 'modalError', 'submitButton']

  showModal (event) {
    ['employeeId', 'userName', 'submitUrl'].forEach(attr => {
      this.additionalParamsTarget.dataset[attr] = event.target.dataset[attr]
    })
    this.additionalParamsTarget.dataset.available = event.target.innerText.trim()
    this.availableTarget.value = event.target.innerText.trim()
    this.commentTarget.value = ''
    this.submitButtonTarget.disabled = true
    $('#CalendarHolidayAvailableId').modal('show')
  }

  enableSubmit () {
    this.submitButtonTarget.disabled = this.availableTarget.value.trim() === this.additionalParamsTarget.dataset.available
  }

  submit (event) {
    event.preventDefault()
    const valueBefore = parseFloat(this.additionalParamsTarget.dataset.available)
    const valueAfter = parseFloat(this.availableTarget.value)
    if (valueBefore === valueAfter) return

    const transactionDays = valueAfter - valueBefore
    const transactionType = transactionDays >= 0 ? 'add' : 'remove'
    const transactionYear = this.yearValue
    const employeeId = this.additionalParamsTarget.dataset.employeeId

    const data = {
      calendar_holiday_entitlement: {
        transaction_type: transactionType,
        year: transactionYear,
        days: Math.abs(transactionDays),
        comment: this.commentTarget.value.trim(),
        user_commented: true
      }
    }

    return $.ajax({
      method: 'POST',
      dataType: 'json',
      url: this.additionalParamsTarget.dataset.submitUrl,
      data,
      success: () => {
        $(`#holiday-available_employee_${employeeId}`).text(this.availableTarget.value)
        $('#CalendarHolidayAvailableId').modal('hide')
        const container = $(`#stats-details_employee_${employeeId}`)
        const accruedContainer = $('.stats-accrued dd', container)
        const availableContainer = $('.stats-available dd', container)

        accruedContainer.text(parseInt(accruedContainer.text()) + transactionDays)
        availableContainer.text(valueAfter)
      },
      error: (error) => {
        this.modalErrorTarget.textContent = error.responseText
        this.modalErrorTarget.classList.remove('d-none')
      }
    })
  }
}

export default EventTypeReportController
